const env = process.env

export default {
  isProduction: env['NODE_ENV'] === 'production',
  token: 'APP_AUTH_TOKEN',
  name: null,
  showUi: null
}
